<template>

  <ModalContainer :queryParam="activeQueryParam" ref="modalContainer" size="lg">
    <fieldset :disabled="onlyView">

      <b-card>
        <h4 class="text-center">{{
          onlyView 
            ? 'Ver Item Laboratorio' 
            : esCrear
              ? 'Crear Item Laboratorio' 
              : 'Editar Item Laboratorio'
        }}</h4>
  
        <b-form @submit.prevent="onSaveLaboratorio" class="mt-2 row">
          
          <b-form-group label="Código:" label-for="codigo" class="col-6">
            <b-form-input
              id="codigo"
              v-model="laboratorio.codigo"
              type="text"
              required 
            />
          </b-form-group>
          
  
          <b-form-group label-for="area" class="col-6">
            <label>Area Analasis: <span class="text-danger">*</span></label>
            <validation-provider #default="{ errors }" name="area" rules="required">
              <v-select 
                id="area" v-model="laboratorio.area"
                placeholder="Buscar por area." 
                :options="areasa" 
                :reduce="option => option"
                label="text" 
                class="d-inline-block w-100"
                :disabled="onlyView"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
  
  
          <b-form-group label="Descripcion:" label-for="descripcion" class="col-12">
  
            <b-form-input
              id="descripcion"
              v-model="laboratorio.descripcion"
              type="text"
              required 
            />
  
          </b-form-group>
  
  
          <hr class="col-12">
  
          <b-row class="col-12">
            <h6 class="col-12">Precio:</h6>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">ISSFA N1</label>
              <InputNumber v-model="laboratorio.precios.issfa_n1" decimal/>
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">ISSFA N2</label>
              <InputNumber v-model="laboratorio.precios.issfa_n2" decimal/>
            </div>
  
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">IESS N1</label>
              <InputNumber v-model="laboratorio.precios.iess_n1" decimal/>
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">PARTICULAR</label>
              <InputNumber v-model="laboratorio.precios.particular" decimal/>
            </div>
  
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 100px;">ISSPOL N1</label>
              <InputNumber v-model="laboratorio.precios.isspol_n1" decimal/>
            </div>
          </b-row>
  
          <hr class="col-12">
  
          <b-row class="col-12">
            <h6 class="col-12">Estados:</h6>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">IESS</label>
  
              <b-form-checkbox 
                v-model="laboratorio.estados.iess" 
                switch
              />
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">ISSFA</label>
  
              <b-form-checkbox 
                v-model="laboratorio.estados.issfa" 
                switch
              />
            </div>
  
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">ISSPOL</label>
  
              <b-form-checkbox 
                v-model="laboratorio.estados.isspol" 
                switch
              />
            </div>
  
            <div class="col-6 d-flex align-items-center mb-1">
              <label for="" class="mb-0 mr-2" style="width: 80px;">PARTICULAR</label>
  
              <b-form-checkbox 
                v-model="laboratorio.estados.particular"
                switch
              />
            </div>
          </b-row>

          <hr class="col-12">

          <b-row class="col-12">
            <h6 class="col-12">Establecimientos:</h6>
            <div class="row estab-grid col-12">
              <div
                v-for="est in establecimientosEstado"
                :key="est.value"
                class="col-6 mb-2"
              >
                <div class="estab-item">
                  <span class="estab-label">{{ est.text }}</span>
                  <b-form-checkbox
                    v-model="est.activo"
                    switch
                    class="mb-0"
                    :disabled="onlyView"
                  />
                </div>
              </div>
            </div>
          </b-row>

          <div v-if="!onlyView" class="col-12 d-flex justify-content-end mt-3">
            <b-button type="submit" variant="primary" class="mx-2">
              Guardar laboratorio
            </b-button>

            <b-button @click="onCancel" variant="danger">
              Cancelar
            </b-button>
          </div>
          
        </b-form>
      </b-card>
    </fieldset>
  </ModalContainer>
  
  
</template>
  
<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate';
import { required } from '@validations'
import { ModalContainer, InputNumber } from '@/shared/components'
import { carteraLaboratorioService }   from '@/views/laboratorio/services';
import { getEstablecimientoLS } from '../../../../shared/helpers';
  
export default {

  name: 'EditarLaboratorio',

  components: {
    ValidationProvider,
    vSelect,
    ModalContainer,
    InputNumber
  },


  data() {
    return {

      esCrear: false,
      required,
      localIsVisible: false,

      establecimientos: [],
      establecimientosEstado: [],
      areasa: [],

      laboratorio: {
        id: '',
        token:'',
        descripcion: '',
        codigo: '',
        area:'',
        establecimiento: '',
        establecimientosEstado: [],

        precios: {
          issfa_n1: "0",
          issfa_n2: "0",
          iess_n1: "0",
          particular: "0",
          isspol_n1: "0"
        },

        estados: {
          iess: false,
          issfa: false,
          isspol: false,
        particular: false
        },
      },
    };
  },

  async created() {
    await this.fetchEstablecimientos();
    await this.fetchAreaAnalisis();
    await this.getData();
  },

  methods: {

    clearForm() {
      this.laboratorio = {
        id: '',
        token:'',
        descripcion: '',
        codigo: '',
        area:'',
        establecimiento: '',

        precios: {
          issfa_n1: "0",
          issfa_n2: "0",
          iess_n1: "0",
          particular: "0",
          isspol_n1: "0"
        },

        estados: {
          iess: false,
          issfa: false,
          isspol: false,
          particular: false
        }
      }
      this.establecimientosEstado = [];
    },



    async getData() {
      this.clearForm();
      this.esCrear = false
      this.esView = false
      
      const tokenSave = this.$route.query.saveLab;
      const tokenView = this.$route.query.viewLab;

      if(tokenView){
        this.esView = true
      }

      if(!tokenView) {
        
        if(!tokenSave || tokenSave === '0' ) {
          this.esCrear = true
          return;
        }
      }


      const tokenLab = tokenView || tokenSave;

      const params = {
        tokenLab: tokenLab
      };

      const response = await carteraLaboratorioService.getAll( params );
      if(!response || !response.laboratorios) return;

      const laboratorio = response.laboratorios[0];

      const areaAnalisis = {
        value: laboratorio.areaanalisis.id,
        text : laboratorio.areaanalisis.descripcion
      }

     const estados  = laboratorio.estadoJson ? JSON.parse(laboratorio.estadoJson) : {};
     const precios = laboratorio.precioJson ? JSON.parse(laboratorio.precioJson) : {};

      const laboratorioMap = {
        id              : laboratorio.id,
        token           : laboratorio.token,
        establecimiento : laboratorio.establecimiento?.id || laboratorio.establecimiento || '',
        descripcion     : laboratorio.descripcion,
        codigo          : laboratorio.codigo,
        precio          : laboratorio.precio,
        area            : areaAnalisis,
        estados         : estados,
        precios         : precios
      };

      this.laboratorio = laboratorioMap;
      this.syncEstablecimientosEstado();

    },


    onCancel() {
      this.localIsVisible = false
    },


    async onSaveLaboratorio(){

      const validationForm = this.validateForm();

      if(!validationForm) return;

      const establecimiento  = this.esCrear 
        ? getEstablecimientoLS()?.id
        : this.laboratorio.establecimiento; 

     const laboratorioToSave = {
        id              : this.laboratorio.id || null,
        establecimiento : (this.establecimientosEstado && this.establecimientosEstado.length)
          ? this.establecimientosEstado
              .filter(e => e.activo)
              .map(e => e.value)
              .join(",")
          : establecimiento,
        descripcion     : this.laboratorio.descripcion,
        codigo          : this.laboratorio.codigo,
        area            : this.laboratorio.area?.value,
        estados         : this.laboratorio.estados ? JSON.stringify(this.laboratorio.estados) : null,
        precios         : this.laboratorio.precios ? JSON.stringify(this.laboratorio.precios) : null
      }

      if (this.esCrear) {
        delete laboratorioToSave.id;
      }

      if(!laboratorioToSave.estados){
        console.error('no hay dato de estados en el laboratorio a actualizar');
        return;
      }

      if(!laboratorioToSave.precios){
        console.error('no hay dato de precios en el laboratorio a actualizar');
        return;
      }


      // console.log("laboratorioToSave", laboratorioToSave, this.esCrear);
      // return;
      
      const responseSave = this.esCrear 
        ? await carteraLaboratorioService.createItem(laboratorioToSave) 
        : await carteraLaboratorioService.updateItem(laboratorioToSave);


      if(!responseSave) {
        await this.$swal({
          icon: 'error',
          title: 'No se pudo actualizar el laboratorio',
          showConfirmButton: true,
        });

        return;
      }

      await this.$refs.modalContainer.closeModal();

      await this.$swal({
        icon: 'success',
        title: 'Laboratorio actualizado',
        showConfirmButton: true,
      })
      this.$router.go(0);
    },


    validateForm(){

      const errors = [];

      if(!this.laboratorio.codigo)
        errors.push('Debe ingresar el codigo del laboratorio');

      if(!this.laboratorio.descripcion)
        errors.push('Debe ingresar la descripcion del laboratorio');

      if(!this.laboratorio.area.value)
        errors.push('Debe ingresar el area de analisis');

      if(errors.length === 0) return true;

      const mensajeError = errors.join(', ');

      this.$swal({
        title: "Error",
        text: mensajeError,
        icon: "error",
        showConfirmButton: true,
      });

      return false;
    },




    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value    : item.id,
          text     : item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
        this.syncEstablecimientosEstado();
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },


    async fetchAreaAnalisis() {
      const query = `
        query obtenerAreaAnalisis {
          allAreaslab {
            descripcion
            id
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.areasa = response.data.data.allAreaslab.map(item => ({
          value: item.id,
          text: item.descripcion
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },

    mapEstablecimientosEstado(establecimientosVal = '') {
      const ids = Array.isArray(establecimientosVal)
        ? establecimientosVal.map(e => (e.id ? e.id : e)).map(i => String(i).trim())
        : establecimientosVal
            .toString()
            .split(',')
            .map(i => i.trim())
            .filter(Boolean);

      const baseList = this.establecimientos && this.establecimientos.length
        ? this.establecimientos
        : ids.map(id => ({ value: id, text: id }));

      return baseList.map(est => ({
        ...est,
        activo: ids.includes(String(est.value)),
      }));
    },

    syncEstablecimientosEstado() {
      const mapped = this.mapEstablecimientosEstado(
        this.laboratorio.establecimiento
      );
      this.establecimientosEstado = mapped;
      this.laboratorio.establecimientosEstado = mapped;
    },

  },


  computed: {
    activeQueryParam() {
      const query = this.$route.query;
      if ('saveLab' in query) return 'saveLab';
      return ''; // evita prop nula en ModalContainer
    },

    onlyView() {
      return this.activeQueryParam === 'viewLab';
    }
  },


  watch: {

    '$route.query.saveLab': {
      deep: true,
      handler(newValue) {
        if(newValue) this.getData();
      }
    },


    laboratorio: {
      deep: true,
      handler(newValue) {
        if(newValue) console.log("laboratorio", newValue)
      }
    },

    establecimientos: {
      deep: true,
      handler() {
        this.syncEstablecimientosEstado();
      }
    },

  }
};
</script>

  
